const ANIMATION_DURATION = 300;

function easeInOutQuad(t) {
	return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

/**
 * Animates height between current and target values.
 *
 * @param {HTMLElement} el
 * @param {number} from
 * @param {number} to
 * @param {Function} [onComplete]
 */
function animateHeight(el, from, to, onComplete) {
	const startTime = performance.now();

	function step(now) {
		const progress = Math.min((now - startTime) / ANIMATION_DURATION, 1);
		const eased = easeInOutQuad(progress);

		const current = from + (to - from) * eased;
		el.style.height = `${current}px`;

		if (progress < 1) {
			requestAnimationFrame(step);
		} else {
			if (onComplete) onComplete();
		}
	}

	requestAnimationFrame(step);
}

document.addEventListener("DOMContentLoaded", () => {
	const accordions = document.querySelectorAll(
		".wp-block-leopolis-new-design-adface-accordion",
	);

	accordions.forEach(initAccordion);
});
function initAccordion(accordion) {
	const items = accordion.querySelectorAll(
		".wp-block-leopolis-new-design-adface-accordion-item",
	);

	items.forEach((item) => {
		const trigger = item.querySelector(
			".wp-block-leopolis-new-design-adface-accordion-item__trigger",
		);

		if (!trigger) return;

		trigger.addEventListener("click", () => {
			const isOpen = item.classList.contains("is-open");

			// close all others
			items.forEach((other) => {
				if (other !== item) closeItem(other);
			});

			// toggle clicked
			if (isOpen) {
				closeItem(item);
			} else {
				openItem(item);
			}
		});
	});
}

function closeItem(item) {
	const trigger = item.querySelector(
		".wp-block-leopolis-new-design-adface-accordion-item__trigger",
	);
	const content = item.querySelector(
		".wp-block-leopolis-new-design-adface-accordion-item__content",
	);

	if (!trigger || !content) return;

	// IMPORTANT: freeze current height FIRST
	const startHeight = content.getBoundingClientRect().height;

	content.style.height = `${startHeight}px`;

	// force reflow (critical for isolation)
	content.offsetHeight;

	// now update state
	item.classList.remove("is-open");
	trigger.setAttribute("aria-expanded", "false");

	animateHeight(content, startHeight, 0, () => {
		content.style.height = "0px";
	});
}

function openItem(item) {
	const trigger = item.querySelector(
		".wp-block-leopolis-new-design-adface-accordion-item__trigger",
	);
	const content = item.querySelector(
		".wp-block-leopolis-new-design-adface-accordion-item__content",
	);
	const inner = item.querySelector(
		".wp-block-leopolis-new-design-adface-accordion-item__content-inner",
	);

	if (!trigger || !content || !inner) return;

	item.classList.add("is-open");
	trigger.setAttribute("aria-expanded", "true");

	// measure AFTER state change
	const targetHeight = inner.getBoundingClientRect().height;

	content.style.height = "0px";

	requestAnimationFrame(() => {
		animateHeight(content, 0, targetHeight, () => {
			content.style.height = "auto";
		});
	});
}
